var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M500.3 443.7 380.6 324a208 208 0 0 0 33.5-144.7A209.2 209.2 0 0 0 235.2 1.7 208.2 208.2 0 0 0 1.7 235.2a209.1 209.1 0 0 0 177.6 178.9A207.9 207.9 0 0 0 324 380.6l119.7 119.7a40 40 0 1 0 56.6-56.6zM79.1 208c0-70.6 57.4-128 128-128s128 57.4 128 128-57.4 128-128 128-128-57.4-128-128z"}));
}

Search.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Search;

Search.default = Search;
